import * as types from "../../actions/systemlevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_VENDOR_EMPLOYER_DEDUCTION_DROPDOWN_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
